// 默认配置数据

// 证件类型
export const IDCARD = [{
    value: 1,
    label: '身份证'
}, {
    value: 2,
    label: '护照'
}, {
    value: 3,
    label: '统一社会信用代码'
}]

// 表计类型
export const DEVTYPE = [
    {
        label: '温控器',
        value: 1
    },
    {
        label: '风柜',
        value: 2
    },
    {
        label: '热量表',
        value: 3
    },
    {
        label: 'PLC',
        value: 4
    },
]

// 业主状态
export const LESSEESTATUS = [{
    value: '1',
    label: '开户'
}, {
    value: '2',
    label: '销户'
}]

// 系统类型
export const SYSTEMTYPE = [
    {
        label: '计费系统',
        value: 0,
        disable: false,
    },
    {
        label: '机房系统',
        value: 1,
        disable: false,
    },
    {
        label: '控制系统',
        value: 2,
        disable: false,
    },
	{
	    label: '新机房系统',
	    value: 3,
	    disable: false,
	},
]

// 群控参数
export const CLUSTERMANA = {
    // 状态
    status: [
        {
            label: '开机',
            value: "1",
            disable: false,
        },
        {
            label: '关机',
            value: "0",
            disable: false,
        },
    ],
    // 模式
    pattern: [
        {
            label: '制冷',
            value: "1",
            disable: false,
        },
        {
            label: '通风',
            value: "4",
            disable: false,
        },
        {
            label: '制热',
            value: "8",
            disable: false,
        },
    ],
    // 风速
    windSpeed: [
        {
            label: '高风速',
            value: "8",
            disable: false,
        },
        {
            label: '中风速',
            value: "4",
            disable: false,
        },
        {
            label: '低风速',
            value: "2",
            disable: false,
        },
        {
            label: '自动风速',
            value: "128",
            disable: false,
        },
    ],
    // 锁定
    lock: [
        {
            label: '开关',
            value: "1",
            disable: false,
        },
        {
            label: '温度',
            value: "2",
            disable: false,
        },
        {
            label: '模式',
            value: "4",
            disable: false,
        },
        {
            label: '全锁',
            value: "128",
            disable: false,
        },
        {
            label: '解锁',
            value: "0",
            disable: false,
        },
    ],
    // 来电启动状态
    DDGK: [
        {
            label: '来电保持关机',
            value: "0",
            disable: false,
        },
        {
            label: '来电保持掉电前状态',
            value: "1",
            disable: false,
        },
        {
            label: '来电强制开机',
            value: "2",
            disable: false,
        },
    ],
    // 通风模式使能
    windMode: [
        {
            label: '允许',
            value: "1",
            disable: false,
        },
        {
            label: '禁用',
            value: "0",
            disable: false,
        },
    ],
}

export const CLUSTERMANA_1 = {
    // 状态
    power_on: [
        {
            label: '开机',
            value: "1",
            disable: false,
        },
        {
            label: '关机',
            value: "0",
            disable: false,
        },
    ],
    // 风速
    speed: [
        {
            label: '自动',
            value: "0",
            disable: false,
        },
        {
            label: '高风',
            value: "1",
            disable: false,
        },
        {
            label: '中风',
            value: "2",
            disable: false,
        },
        {
            label: '低风',
            value: "3",
            disable: false,
        },
    ],
    // 模式
    mode: [
        {
            label: '制冷',
            value: "0",
            disable: false,
        },
        {
            label: '通风',
            value: "1",
            disable: false,
        },
        {
            label: '制热',
            value: "2",
            disable: false,
        },
        {
            label: '自动',
            value: "3",
            disable: false,
        },
    ],
    // 按键锁[]
	// 锁定开关机
	// 锁定模式
	// 锁定风速
	// 锁定温度设置
    key_lock: [
        {
            label: '解除锁定',
            value: "0",
            disable: false,
        },
        {
            label: '锁定开关机',
            value: "1",
            disable: false,
        },
        {
            label: '锁定模式',
            value: "2",
            disable: false,
        },
        // {
        //     label: '锁定风速',
        //     value: "3",
        //     disable: false,
        // },
		{
		    label: '锁定开关机,锁定模式',
		    value: "3",
		    disable: false,
		},
        {
            label: '锁定风速',
            value: "4",
            disable: false,
        },
		{
		    label: '锁定开关机,锁定风速',
		    value: "5",
		    disable: false,
		},
		{
		    label: '锁定模式,锁定风速',
		    value: "6",
		    disable: false,
		},
		{
		    label: '锁定开关机,锁定模式,锁定风速',
		    value: "7",
		    disable: false,
		},
		{
		    label: '锁定温度设置',
		    value: "8",
		    disable: false,
		},
		{
		    label: '锁定开关机,锁定温度设置',
		    value: "9",
		    disable: false,
		},
		{
		    label: '锁定模式,锁定温度',
		    value: "10",
		    disable: false,
		},
		{
		    label: '锁定开关机,锁定模式,锁定温度设置',
		    value: "11",
		    disable: false,
		},
		{
		    label: '锁定模式,锁定风速,锁定温度设置',
		    value: "12",
		    disable: false,
		},
		{
		    label: '锁定开关机,锁定风速,锁定温度设置',
		    value: "13",
		    disable: false,
		},
		{
		    label: '锁定模式,锁定风速,锁定温度设置',
		    value: "14",
		    disable: false,
		},
        {
            label: '锁定所有按键操作',
            value: "15",
            disable: false,
        },
    ],
}

// 表计型号
export const METERTYPE = {
    WKQ: [
        {
            value: 'FC810',
            label: 'FC810'
        }
    ],
    FG: [
        {
            value: 'FC890',
            label: 'FC890'
        }
    ],
    RLB: [
        {
            value: 'HM01',
            label: 'HM01'
        }
    ]
}

// 权限分类
export const ROLES = [
    {
        name: '',
        key: ''
    },
]

// 账号类型
export const COUNTTYPE = [
    {
        name: '超级管理员',
        value: '1'
    },
    {
        name: '工程师账号',
        value: '2'
    },
    {
        name: '公司主账号',
        value: '3'
    },
    {
        name: '公司子账号',
        value: '4'
    },
]

// 通知类型
export const Notice_Type = [
    {
        type: 0,
        message: "账号在其他处登录通知",
    },
    {
        type: 1,
        message: "项目报警信息通知",
    },
    {
        type: 2,
        message: "设备实时监听通知",
    },
    {
        type: 3,
        message: "按设备ID监听信息通知"
    },
]

// websocket状态码
export const wsSendType = {
    // 报警通知
    NOTICE: '1',
    ON_NOTICE: '10',
    OFF_NOTICE: "11",
    // 设备监控
    METERREADING: "2",
    ON_METERREADING: "20",
    OFF_METERREADING: "21",
}
